import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

interface AuthActions {
  setAuthenticated: (value: boolean) => void;
  setLoading: (value: boolean) => void;
  setError: (error: string | null) => void;
  clearAuth: () => void;
}

type AuthStore = AuthState & AuthActions;

const initialState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  error: null,
};

export const useAuthStore = create<AuthStore>()(
  devtools(
    (set) => ({
      ...initialState,
      setAuthenticated: (value) => set({ isAuthenticated: value }, false, 'auth/setAuthenticated'),
      setLoading: (value) => set({ isLoading: value }, false, 'auth/setLoading'),
      setError: (error) => set({ error }, false, 'auth/setError'),
      // isLoading omitted so a clear during init doesn't strand callers waiting on a load flag.
      clearAuth: () => set({ isAuthenticated: false, error: null }, false, 'auth/clearAuth'),
    }),
    {
      name: 'AuthStore',
      enabled: import.meta.env.DEV,
    }
  )
);

export const useIsAuthenticated = () => useAuthStore((s) => s.isAuthenticated);
export const useAuthError = () => useAuthStore((s) => s.error);

export default useAuthStore;
